import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "TreasuryKRISummary" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
